module.exports = __webpack_public_path__ + "img/T1D_rc-19.70e17eb4.png";